import { z } from 'zod';
import { EventName } from './EventName';

export const OfflineEventBadDataRequestSchema = z.object({
  eventName: z.nativeEnum(EventName),
  start: z
    .string()
    .regex(
      /^\d{4}-\d{2}-\d{2}$/i,
      'Please specify the proper format of the date, YYYY-MM-DD',
    ),
  end: z
    .string()
    .regex(
      /^\d{4}-\d{2}-\d{2}$/i,
      'Please specify the proper format of the date, YYYY-MM-DD',
    ),
  uploadTags: z.array(z.string()), // upload tags to exclude from match rate calculations
});

export type OfflineEventBadDataRequest = z.infer<
  typeof OfflineEventBadDataRequestSchema
>;

export const exampleOfflineEventBadDataRequest: OfflineEventBadDataRequest = {
  eventName: EventName.AddPaymentInfo,
  start: '2021-01-01',
  end: '2021-03-31',
  uploadTags: [
    'Marketing Milk (business 4) - 9efa01fa-a6d0-4a8f-880b-e99a12828aaf',
    'Cyclr',
  ],
};
